<template>
	<div class="default-page vertical-align-center">
		<b-container>
			<b-row>
				<b-col md="4" class="text-center">
					<div class="avatar">
						<Avatar :avatar="avatarCatNotebook"/>
					</div>
				</b-col>
				<b-col md="4" offset-md="1" class="mt-4 mt-md-0">
					<h1 v-if="showTitle">Login</h1>
					<div v-if="activated" class="mt-5 mt-md-0">
						<p class="font-weight-extra-bold">Die Bestätigung hat geklappt!</p>
						<p>Bitte melde dich jetzt an.</p>
						<p>Wenn du dich auf einem anderen Gerät registriert hast, kannst du dich auch dort nun
							anmelden.</p>
					</div>
					<Login
						class="mt-4"
						:pre-fill-email="email"
					/>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
import {getQueryParams, removeQueryParamsFromUrl} from "@/helper/Url";
import CustomerConfirmEmail from "@/api/customer/security/ConfirmEmail";
import Login from "@/vue/auth/Login"
import ApplicationConfirmEmail from "@/api/application/security/ConfirmEmail";
import flatten from "@/helper/error/Errors";
import * as Toast from "@/helper/layout/Toast"
import Avatar, {CAT_NOTEBOOK} from "@/vue/common/image/Avatar.vue";
import * as Event from "@/helper/tracking/Event";
import EventData from "@/helper/tracking/EventData";

export default {

	components: {
		Avatar,
		Login,
	},

	data ()
	{
		const queryParams = getQueryParams();

		return {
			activated: queryParams.activated,
			email: undefined,
			checkedConfirmation: false,
		};
	},

	computed: {
		showTitle ()
		{
			return this.checkedConfirmation && !this.activated;
		},
		avatarCatNotebook ()
		{
			return CAT_NOTEBOOK;
		}
	},

	async mounted ()
	{
		const queryParams = getQueryParams();

		this.email = queryParams.email;

		if (queryParams.cid)
		{
			try
			{
				const response = await new CustomerConfirmEmail()
					.setId(queryParams.cid)
					.call();

				this.email = response.data.email;
				this.activated = true;

				this.trackActivatedEvent();

				removeQueryParamsFromUrl();
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}
		}

		if (queryParams.aid && queryParams.ast)
		{
			try
			{
				const response = await new ApplicationConfirmEmail()
					.setId(queryParams.aid)
					.setSecurityToken(queryParams.ast)
					.call();

				this.email = response.data.email;
				this.activated = true;

				this.trackActivatedEvent();

				removeQueryParamsFromUrl();
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}
		}

		this.checkedConfirmation = true;
	},

	methods: {
		trackActivatedEvent ()
		{
			Event.push(
				new EventData()
					.setEvent(Event.REGISTRATION)
					.setAction('E-Mail bestätigt durch Kandidat')
			);
		}
	}
}
</script>
